import React, { useRef } from 'react';
import * as Highcharts from 'highcharts';
import { HighchartsReact } from 'highcharts-react-official';
import { CHART_COLORS } from '@/constants/common';
import { IMailboxSession } from '../types';

interface MailboxGraphProps {
  width: number;
  mailboxSession?: IMailboxSession;
}

const getOptions = ({ width, mailboxSession }: MailboxGraphProps): Highcharts.Options => { 

  return({
    chart: {
        type: 'pie',
        margin: 0,
        height: width/2 - 10,
        marginLeft: width/2 + 20,
        width: width,
    },
    title: {
        text: ''
    },

    plotOptions: {
        pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
                enabled: false
            },
            showInLegend: true,
            innerSize: '65%',
            size: '80%'
        }
    },
    legend: {
        align: 'left',
        verticalAlign: 'middle',
        width: 200,
        alignColumns: false,
        useHTML: true,
        itemMarginTop: 10,
        itemStyle: {
          lineHeight: 1
        },
        labelFormatter: function () {
            const series = this;
            const isTotal = series.name === 'Total emails'
            return `
              <div style="display: flex; gap: 4px; align-items: center;">
                <span style="display: inline-block; width: 120px; ${isTotal ? 'font-weight: 700' : ''}">
                  ${this.name}
                </span>
                <b>${(this as unknown as any).y}</b>
              </div>
            `;
        }
    },
    series: [
        { 
            type: 'pie', 
            visible: true, 
            color: 'red',
            data: [['Total emails', mailboxSession?.totalEmails ?? 0]],
            legendSymbol: 'lineMarker',
            name: 'Total emails',
        },
        {
            type: 'pie',
            name: 'count',
            data: [
                { y: mailboxSession?.unprocessedEmails ?? 0, name: 'Unprocessed emails', color: CHART_COLORS[0]}, 
                { y: mailboxSession?.processedEmails ?? 0, name: 'Processed emails', color: CHART_COLORS[1]}, 
                { y: mailboxSession?.reviewEmails ?? 0, name: 'Emails for reviews', color: CHART_COLORS[2]}, 
                { y: mailboxSession?.failedEmails ?? 0, name: 'Failed emails', color: CHART_COLORS[3]}, 
            ],
            
        }]
})};



const MailboxGraph = (props: MailboxGraphProps) => {
  const chartComponentRef = useRef<HighchartsReact.RefObject>(null);

  return (
    <HighchartsReact
      highcharts={Highcharts}
      options={getOptions(props)}
      ref={chartComponentRef}
    />
  );
};

export default MailboxGraph;
